import Typography from '@mui/material/Typography';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Button } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useGlobalCore } from '../../../core/modules/global';
import { CREATE_COMPANY_DIALOG } from '../../../core/constants/dialog';
import { useCompanyCore } from '../../../core/modules/company';
import { useMeCore } from '../../../core/modules/me';

const Header = () => {
  const { user } = useMeCore();
  const { total } = useCompanyCore();
  const { openDialog } = useGlobalCore();

  const canWrite = useMemo(() => user && (user.privileges.superAdmin), [user]);

  const openCreateDialog = useCallback(() => {
    openDialog(CREATE_COMPANY_DIALOG);
  }, [openDialog]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Compañias
          </Typography>
          <Typography className="text-14 font-medium" color="text.secondary">
            {total} compañia/s
          </Typography>
        </div>
        {canWrite && (
          <Button
            variant="contained"
            color="secondary"
            onClick={openCreateDialog}
          >
            <AddCircleOutlineOutlinedIcon />
            <span className="mx-8">Crear</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default Header;
